<template minapp='mpx' xlang='wxml'>

      <!-- 证件列表 -->
    <view class="es-content__box" wx:if="{{isCardListShow}}">
      <view wx:for="{{ innerValue }}" class="es-content__vbox">
        <view class="es-content__card">
          <es-card layout="{{index === 0?['header']:[]}}" custom-header='es-content__miniapp_card_header' custom-body='es-content__miniapp_card_body'>
            <view slot='header' wx:if="{{index === 0}}">证件信息</view>
            <es-credentials 
              isAddPage="{{isAddPage}}"
              cardType="{{item}}"
              secretKey="{{secret_key}}"
              isCanDelete="{{!isOneCardShow}}"
              isIdNoDisable="{{isIdNoDisable}}"
              isIdTypeDisable="{{isIdTypeDisable}}"
              cardTypeList="{{ isOneCardShow ? originCardTypeList : cardTypeList }}"
              isRequiredShow="{{isOneCardShow ?  false : isRequiredShow}}"
              expireDateConfig="{{expireDateConfig }}"
              aesOriginCardList="{{aesOriginCardList}}"
              bind:change-item="changeCardType" 
              bind:delete-item="deleteCardType" 
              bind:input-change="inputCardNo"
              bind:expired-date-change="changeExpiredDate"
            />
          </es-card>
        </view>
      </view>
    </view>
</template>

<script>
  import { watch } from '@mpxjs/core'
  import { AES_ECB_DECRYPT } from '@/common/crypto'
  import { createComponent } from '@didi/es-mpx-creator'
  import { formatDate } from '@didi/es-mpx-shared'
  import { findIndex } from 'lodash'
  import store from '@/store'
  import selectCountryPage from '@/pages/contact/selectCountry.mpx?resolve'
  import { hasRequired } from '@/utils'

  createComponent({
    classes: [],
    data: {
      innerValue: [],
      isChange: false,
      selectedCardList: [],
      innerSelectedCardType: ''
    },
    props: {
      value: {
        type: Array,
        value: []
      },
      isAddPage:{
        type: Boolean,
        value: true
      },
      isCardListShow: {
        type: Boolean,
        value: true
      },
      isRequiredShow: {
        type: Boolean,
        value: true
      },
      isOneCardShow: {
        type: Boolean,
        value: true
      },
      isIdTypeDisable: {
        type: Boolean,
        value: true
      },
      isIdNoDisable: {
        type: Boolean,
        value: true
      },
      cardTypeList: {
        type: Array,
        value: []
      },
      secret_key: {
        type: String,
        value: ''
      },
      aesOriginCardList: {
        type: Array,
        value: []
      },
      initSelectedCardList: {
        type: Array,
        value: []
      },
      selectedCardType: {
        type: String,
        value: ''
      },
      //是否展示证件有效期
      expireDateConfig: {
        type: Object,
        value: {}
      },
      selected_card_type: {
        type: String,
        value: ''
      },
    },
    computed: {
      ...store.mapState({
        originCardTypeList: 'newContacts.cardTypeList'
      })
    },
    methods: {
      changeCardType(e) {
        this.innerSelectedCardType = e.detail.target.code
        // 常用编辑
        if (!this.isOneCardShow) {
          this.selectedCardList = [{...e.detail.target}]
        }
      },
      // 删除证件
      deleteCardType(e) {
        // 1. 选中的列表删除
        const selectIndex = findIndex(this.selectedCardList, (item) => {
          return item.card_type == e.detail.card_type
        })
        this.selectedCardList.splice(selectIndex, 1)

        // 2. 未选中的列表添加
        this.cardTypeList.push(e.detail)
        this.cardTypeList.sort((a, b) => {
          return a.card_type - b.card_type
        })
      },
      // 输入证件卡号
      inputCardNo(e) {
        const { card_type, value, isChange = true } = e.detail
        this.isChange = isChange
        if (this.selectedCardList?.length) {
          this.selectedCardList = this.selectedCardList.map((item) => {
            if (item.card_type == card_type) {
              item.id_no = value
              item.isChange = true
            }
            return item
          })
        }
      },
      // 选择证件有效期
      changeExpiredDate(e) {
        const { card_type, value } = e.detail
        if (this.selectedCardList?.length) {
          this.selectedCardList = this.selectedCardList.map((item) => {
            if (item.card_type == card_type) {
              item.expire_date = value
            }
            return item
          })
        }
      },
      getSelectedCardList(val) {
        if (!this.isOneCardShow) {
          this.innerValue = val
        } else {
          let newValue = val
          // 选择页面进入时
          const temp = []
          // 无证件信息，分2种情况：
          // 1. 用户本身无证件信息
          // 2. 新增
          if (
            newValue.length === 0 &&
            (this.selected_card_type == '0' || this.selected_card_type == '')
          ) {
            if (this.cardTypeList.length > 0) {
              temp.push(this.cardTypeList.shift())
              if (temp[0]) {
                this.innerSelectedCardType = temp[0].card_type
                this.selectedCardList = temp
              }
            }
            // 有证件时，选择对应的证件
          } else {
            const index = findIndex(newValue, (item) => {
              return item.card_type == this.innerSelectedCardType
            })
            if (index !== -1) {
              temp.push(newValue[index])
            }
          }
          this.innerValue = temp
        }
      }
    },
    watch: {
      value(val) {
        if (JSON.stringify(this.innerValue) == JSON.stringify(val)) {
          return
        }
        this.innerValue = val
      },
      selectedCardList(val = []) {
        const cardInfo = val?.map((item = {}) => {
          const idNo = item?.id_no ?? ''
          return {
            ...item,
            id_no: this.isAddPage
 							? idNo
 							: this.isIdNoDisable
 							? AES_ECB_DECRYPT(idNo)
 							: this.isChange
 							? idNo
 							: AES_ECB_DECRYPT(idNo)
          }
        })
        this.getSelectedCardList(cardInfo)
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger('input', { value: newValue })
      },
      initSelectedCardList(newValue) {
        this.selectedCardList = newValue
      },
      selectedCardType(newValue) {
        this.innerSelectedCardType = newValue
      },
      cardTypeList() {
        if (this.innerValue.length === 0) {
          const defaultInfo = {
            code: "1",
            id_no: "",
            card_type: "1",
            name: "中国居民身份证",
            card_name: "中国居民身份证",
            expire_date: ""
          }
          // 原本参数为空数组, 导致证件 card 显示不出来
          // 新增时证件类型暂默认写死传入二代身份证 - 2023.06.04
          this.getSelectedCardList([defaultInfo])
          this.selectedCardList.push(defaultInfo)
        }
      }
    }
  })
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('add')
      margin 0 12px 12px
    +e('name-box')
      display flex
      width 80px
    +e('required-text')
      color #F93822
    +e('miniapp_cell')
      height 54px
      color #333333
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #f0f2f7
        left 76px
        right 0
    +e('foreigner')
      font-size 12px
      line-height 1
      color #999999
      transform scale(0.83)
      margin-left -4px
    +e('box')
      margin 12px
    +e('card')
      background-color #ffffff
      border-radius 8px
      color #333333
      /deep/ .placeholder
        color #999999
      // h5用
      /deep/ .es-card__header
        line-height 38px
        font-size 16px
        font-weight bold
        margin 4px 12px
        padding 0
        border-bottom 0.5px solid rgba(235, 237, 240, 0.6)
      // h5用
      /deep/ .es-cell
        height 54px
        color #333333
        padding 10px 0
        &::after
          border-bottom 1px solid #f0f2f7
          left 76px
          right 0
      // h5用
      /deep/ .es-cell:last-child
        &::after
          // border-bottom none
      // h5用
      /deep/ .es-cell-custom
        height 44px
        &::after
          border-bottom 1px solid #eeeeee
          left 0
          right 0
      // h5用
      /deep/ .es-cell-custom:last-child
        &::after
          border-bottom 1px solid #eeeeee
      // h5用
      /deep/ .es-field__body
        color currentColor
    // 小程序用
    +e('miniapp_card_header')
      line-height 38px
      font-size 16px
      font-weight bold
      margin 4px 12px
      padding 0
    // 小程序用
    +e('miniapp_card_body')
      padding 0 12px !important
    // 小程序用
    +e('vbox')
      margin 12px 0
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'es-card': '@didi/es-mpx-ui/lib/card',
      'es-credentials': '../../credentials',
      'add-button': '../../add-button'
    }
  }
</script>

